import { render, staticRenderFns } from "./AppraiserValuationCadastralRef.vue?vue&type=template&id=1489dbe2&"
import script from "./AppraiserValuationCadastralRef.vue?vue&type=script&lang=ts&"
export * from "./AppraiserValuationCadastralRef.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports